import React, { useState } from 'react'
import email from '@assets/images/Advertisement/email.svg'
import whtspp from '@assets/images/Advertisement/whtspp.svg'
import arrow from '@assets/images/Advertisement/arrow.svg'
import MyImage from '@shared/components/myImage'

import Link from 'next/link'
import styles from '@shared/components/Advertisement/PricingPlans/plans.module.scss'

const pricingPlansConfig = [
  {
    title: 'Starter Plan',
    price: '$5,000/month',
    description: 'For Small Businesses or Individuals',
    features: ['Banners on the homepage or selected pages', '1 Sponsored Article', 'Social Media Promotion (1 post/week)', 'Email support', 'Growth Plan (Most Popular)']
  },
  {
    title: 'Growth Plan',
    price: '$12,000/month',
    description: 'For growing businesses',
    features: ['Prime Banner Placement on High-Traffic Pages', '2 Sponsored Articles', 'Social Media Promotion (3 posts/week)', 'CTA Buttons on Popular Sections', 'Dedicated Support Team'],
    mostPopular: 'Most Popular'
  },
  {
    title: 'Enterprise Plan',
    price: 'Custom Pricing',
    description: 'For Large Businesses/Custom Needs',
    features: ['Customized Full-Screen Ads and Widgets', 'Unlimited Sponsored Articles', 'Social Media Promotion (Daily Posts + Campaigns)', 'Real-Time Analytics and In-Depth Insights', '24/7 Dedicated Account Manager'],
    isBusiness: true
  }
]

const Plans = () => {
  const [expandedIndex, setExpandedIndex] = useState(null)

  const toggleExpansion = index => {
    setExpandedIndex(expandedIndex === index ? null : index)
  }
  return (
    <section id = 'plancard'>
      <div className={styles.container}>
        <h1 className={styles.containerH1}>Our Plans</h1>
        <div className={styles.plansWrapper}>
          {pricingPlansConfig.map((plan, i) => (
            <div key={plan.title} className={`${styles.plan} ${plan.isBusiness ? styles.business : ''}`}>
              <div>
                <div className={styles.planHeader}>
                  <h3 className={`${styles.planTitle} ${plan.isBusiness ? styles.businessTitle : styles.defaultTitle}`}>{plan.title}</h3>
                  {plan.mostPopular && <span className={styles.mostPopularBadge}>{plan.mostPopular}</span>}
                </div>
                <p className={`${styles.planDescription}`}>{plan.description}</p>
                <p className={styles.planPrice}>{plan.price}</p>
              </div>
              <div>
                <ul className={styles.planFeatures}>
                  {plan.features.map(feature => (
                    <li key={feature}>
                      <span className={styles.featureCheck}>✓</span>
                      {feature}
                    </li>
                  ))}
                </ul>
              </div>
              <div className={styles.buttonsWrapper}>
                <Link href="mailto:hi@oneturf.news" target="_blank">
                  <button className={styles.emailButton}>
                    <MyImage src={email} alt="Mail icon" width={30} height={30} />
                    <span>Email</span>
                  </button>
                </Link>
                  <button className={styles.whatsappButton}>
                    <MyImage src={whtspp} alt="WhatsApp icon" width={30} height={30} />
                    <span>WhatsApp</span>
                  </button>
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className={styles.smContainer}>
        <div className={styles.mobilePlans}>
          <h3 style={{
            textAlign: 'center'
          }}>Our Plans</h3>
          {pricingPlansConfig.map((plan, index) => (
            <div key={index} className={`${styles.smPlanCard} ${plan.isBusiness ? styles.businessPlan : styles.defaultPlan}`}>
              <div className={styles.smplanHeading} onClick={() => toggleExpansion(index)}>
                <div className={styles.smPlanDetails}>
                  <span className={`${styles.smPlanTitle} ${plan.isBusiness ? styles.businessTitle : styles.defaultTitle}`}>
                    {plan.title}
                  </span>
                  <span className={styles.smPlanDescription}>{plan.description}</span>
                  <span className={styles.smPlanPrice}>{plan.price}</span>
                </div>
                <MyImage
                  src={arrow}
                  width={16}
                  height={12}
                  alt="Toggle arrow"
                  className={`${styles.toggleArrow} ${expandedIndex === index ? styles.expanded : ''}`}
                />
              </div>
              <div className={`${styles.planContent} ${expandedIndex === index ? styles.expandedContent : ''}`}>
                <ul className={styles.featureList}>
                  {plan.features.map((feature, i) => (
                    <li key={i} className={styles.featureItem}>
                      <span className={styles.featureCheck}>✓</span>
                      {feature}
                    </li>
                  ))}
                </ul>
                <div className={styles.actionButtons}>
                  <Link href="mailto:hi@oneturf.news" target="_blank">
                    <button className={styles.smEmailButton}>
                      <MyImage src={email} alt="Mail icon" width={20} height={20} />
                      <span>Email</span>
                    </button>
                  </Link>
                    <button className={styles.smWhatsappButton}>
                      <MyImage src={whtspp} alt="WhatsApp icon" width={20} height={20} />
                      <span>WhatsApp</span>
                    </button>

                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default Plans
